import * as React from "react";
import PropTypes from "prop-types";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";

const ToggleButtons = ({ items = [], value, setValue }) => {
  const toggleButtonStyle = {
    width: "21.5vw",
    height: "40px",
    borderRadius: 2,
  };

  return (
    <ToggleButtonGroup value={value} exclusive onChange={setValue}>
      {items.map((item, index) => (
        <ToggleButton value={item.id} key={index} sx={toggleButtonStyle}>
          {item.label}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};

ToggleButtons.propTypes = {
  items: PropTypes.array,
  value: PropTypes.string,
  setValue: PropTypes.func,
};

export default ToggleButtons;
